import React, { useState, useEffect } from "react"
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useTranslation } from "react-i18next";
import { useNavigate  } from "react-router-dom";
import { getPersonInquiryList } from "./actions";


function Demo() {
    const [lang] = useTranslation("language");
    const navigate = useNavigate();
    const [personList, setPersonList] = useState([]);
    const [limit, setLimit] = useState(40);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState();

    const [sortCode, setSortCode] = useState("asc");
    const [sortKanjiName, setSortKanjiName] = useState("asc");
    const [sortKanaName, setSortKanaName] = useState("asc");
    const [sortGender, setSortGender] = useState("asc");
    const [sortCustomerType, setSortCustomerType] = useState("asc");
    const [sortGraduatedUniversity, setSortGraduatedUniversity] = useState("asc");
    const [sortGraduatedYear, setSortGraduatedYear] = useState("asc");


    useEffect(() => {
        async function fetchPersonData() {
            try {
                setLoading(true);
                let payload = { "personNameKanji": "", "personNameKana": "", "facilityNameKanji": "", "facilityNameKana": "", "unifiedCustomerCode": "36", "medicalSpecialityOneID": "", "medicalSpecialityTwoID": "", "allocatedSalesOfficeID": "", "empID": [], "custTypeID": "", "ultmarcRecordID": "", "hundredBedsType": "", "facilityFunctionType": "", "facilityClassType": "", "uniID": "", "gradutedYearFrom": "", "gradutedYearTo": "", "limit": 0, "totalRecords": 0 }
                await getPersonInquiryList(payload).then((response) => {

                    if (
                        (response.success === true && response.data.length === 0) ||
                        response.success === false
                    ) {
                        // setIsLoading(false);
                        setLoading(false);
                        // setNoData(true);
                        setPersonList([]);
                    }
                    if (response.success === true && response.data.length > 0) {
                        // setIsLoading(false);
                        setLoading(false);
                        let id = "";
                        let name = "";
                        var result =
                            response &&
                            response.data.map(function (el) {
                                var o = Object.assign({}, el);
                                id = o && o.genderNameLocal && o.genderNameLocal.key;
                                o.genderId = id;
                                name = o && o.genderNameLocal && o.genderNameLocal.value;
                                o.genderName = name ? name : "";
                                return o;
                            });
                        setPersonList(result);
                        setTotal(response && response.data[0].total);
                        // setNoData(false);
                    }

                });
            } catch (error) {
                console.error("Error fetching person data:", error);
                setLoading(false);
            }
        }

        fetchPersonData();
    }, [])

    const handleContainerOnBottom = async () => {
        let payload = {
            "personNameKanji": "", "personNameKana": "", "facilityNameKanji": "", "facilityNameKana": "", "unifiedCustomerCode": "36", "medicalSpecialityOneID": "", "medicalSpecialityTwoID": "", "allocatedSalesOfficeID": "", "empID": [], "custTypeID": "", "ultmarcRecordID": "", "hundredBedsType": "", "facilityFunctionType": "", "facilityClassType": "", "uniID": "", "gradutedYearFrom": "", "gradutedYearTo": "", limit: personList.length,
            totalRecords: total
        }
        if (personList.length <= total && total >= 30) {
            await getPersonInquiryList(payload).then((response) => {
                let list = [];
                let id = "";
                let name = "";
                var result =
                    response &&
                    response.data.map(function (el) {
                        var o = Object.assign({}, el);
                        id = o.genderNameLocal.key;
                        o.genderId = id;
                        name = o.genderNameLocal.value;
                        o.genderName = name;
                        return o;
                    });
                list = personList.concat(result);
                setPersonList(list);
            });
            setLimit(limit + 10);
        }
    };

    /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
    const handleSortingData = (obj) => {
        /* obj.column === "legacyUnifiedCustomerCode" && setSortCode(obj.sortOrder);   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        obj.column === "unifiedCustomerCode" && setSortCode(obj.sortOrder);            /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        obj.column === "customerName" && setSortKanjiName(obj.sortOrder);
        obj.column === "customerNameLocalKana" && setSortKanaName(obj.sortOrder);
        obj.column === "genderName" && setSortGender(obj.sortOrder);
        obj.column === "customerTypeNameLocal" &&
            setSortCustomerType(obj.sortOrder);
        obj.column === "universityNameLocal" &&
            setSortGraduatedUniversity(obj.sortOrder);
        obj.column === "graduatedYear" && setSortGraduatedYear(obj.sortOrder);
        let list = compareBySortedData(obj);
        setPersonList(list);
    };

    const compareBySortedData = (obj) => {
        const sorted = personList.sort((a, b) => {
            const isReversed = obj.sortOrder === "asc" ? 1 : -1;
            let first = a[obj.column] ? a[obj.column] : "";
            let second = b[obj.column] ? b[obj.column] : "";
            return isReversed * first.localeCompare(second);
        });
        return sorted;
    };

    /*** 
  @purpose : Handle person details
  @Parameter : {id}
  **/
    const handlePersonDetails = (id) => {
        // setShowPersonDetails(true);
        navigate(`/personInfo?personId=${id}`);
    };


    const containerRef = useBottomScrollListener(handleContainerOnBottom);

    return (
       
        <div
            ref={containerRef}
            className="table-responsive mb-0 hover-table max-height"
            onBottom={() => console.log("function call")}
        >
            <table className="table" aria-describedby="table">
                <thead>
                    <tr>
                        <th
                            scope="col"
                            onClick={() =>
                                handleSortingData({
                                    /* column: "legacyUnifiedCustomerCode",  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    column: "unifiedCustomerCode",           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    sortOrder: sortCode === "desc" ? "asc" : "desc",
                                })
                            }
                        >
                            <div className="cursor-pointer">
                                {lang("parentChildFacilityMaintenance.code")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                            </div>
                        </th>
                        <th
                            scope="col"
                            onClick={() =>
                                handleSortingData({
                                    column: "customerName",
                                    sortOrder:
                                        sortKanjiName === "desc" ? "asc" : "desc",
                                })
                            }
                        >
                            <div className="cursor-pointer">
                                {lang("PersonMenu.kanjiName")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                            </div>
                        </th>
                        <th
                            scope="col"
                            onClick={() =>
                                handleSortingData({
                                    column: "customerNameLocalKana",
                                    sortOrder:
                                        sortKanaName === "desc" ? "asc" : "desc",
                                })
                            }
                        >
                            <div className="cursor-pointer">
                                {lang("PersonMenu.kanaName")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                            </div>
                        </th>
                        <th
                            scope="col"
                            onClick={() =>
                                handleSortingData({
                                    column: "genderName",
                                    sortOrder: sortGender === "desc" ? "asc" : "desc",
                                })
                            }
                        >
                            <div className="cursor-pointer">
                                {lang("PersonMenu.gender")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                            </div>
                        </th>
                        <th
                            scope="col"
                            onClick={() =>
                                handleSortingData({
                                    column: "customerTypeNameLocal",
                                    sortOrder:
                                        sortCustomerType === "desc" ? "asc" : "desc",
                                })
                            }
                        >
                            <div className="cursor-pointer">
                                {lang("OrganizationMenu.customerType")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                            </div>
                        </th>
                        <th
                            scope="col"
                            onClick={() =>
                                handleSortingData({
                                    column: "universityNameLocal",
                                    sortOrder:
                                        sortGraduatedUniversity === "desc"
                                            ? "asc"
                                            : "desc",
                                })
                            }
                        >
                            <div className="cursor-pointer">
                                {lang("PersonMenu.graduatedUniversity")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                            </div>
                        </th>
                        <th
                            scope="col"
                            onClick={() =>
                                handleSortingData({
                                    column: "graduatedYear",
                                    sortOrder:
                                        sortGraduatedYear === "desc" ? "asc" : "desc",
                                })
                            }
                        >
                            <div className="cursor-pointer">
                                {lang("PersonMenu.graduatedYear")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {personList.length > 0 &&
                        personList.map((per,index) => {
                            return (
                                per && (
                                    <tr
                                        key={index}
                                        onClick={() =>
                                            handlePersonDetails(per.perCustID)
                                        }
                                    >
                                        <td>
                                            {/* per && per.legacyUnifiedCustomerCode    /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                             /*   ? per.legacyUnifiedCustomerCode       /* SAKAMOTO: AHDD-5861 Ultmarc code change */ }
                                            {per && per.unifiedCustomerCode             /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                                ? per.unifiedCustomerCode               /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                                : ""}
                                        </td>
                                        <td>
                                            {per && per.customerName
                                                ? per.customerName
                                                : ""}
                                        </td>
                                        <td>
                                            {per && per.customerNameLocalKana
                                                ? per.customerNameLocalKana
                                                : ""}
                                        </td>
                                        <td>
                                            {per && per.genderName && per.genderName
                                                ? per.genderName
                                                : ""}
                                        </td>
                                        <td>
                                            {per && per.customerTypeNameLocal
                                                ? per.customerTypeNameLocal
                                                : ""}
                                        </td>
                                        <td>
                                            {per && per.universityNameLocal
                                                ? per.universityNameLocal
                                                : ""}
                                        </td>
                                        <td>
                                            {per && per.graduatedYear
                                                ? per.graduatedYear
                                                : ""}
                                        </td>
                                    </tr>
                                )
                            );
                        })}
                </tbody>
            </table>
        </div>
      
    )
}

export default Demo;